import React from 'react';
import { Link } from 'react-router-dom';

import img1 from '../../assets/OneCommunity1.svg';
import img2 from '../../assets/OneCommunity2.svg';
import img3 from '../../assets/OneCommunity3.svg';

import styles from './OneCommunityThreeWays.scss';

const OneCommunityThreeWays = () => {
  return (
    <div id="OneCommunityThreeWays" className={styles.HowItWorks}>
      <div className={styles.Container}>
        <h3 className={styles.Title}>One Community, Three Ways to Hire</h3>

        <div className={styles.Wrapper}>
          <div className={styles.Column}>
            <div className={styles.Block}>
              <div>
                <div className={styles.imageWrapper}>
                  <img src={img1} alt="" />
                </div>
                <h4 className={styles.StepTitle}>Reach our active community of sellers</h4>
                <ul>
                  <li>Sales-only focus</li>
                  <li>Promoted to our Newsletter and Alerts</li>
                  <li>Free to post</li>
                </ul>
              </div>

              <a className={styles.Request} href="https://jobs.rainmakers.co/">
                Post a Job
              </a>
            </div>
          </div>

          <div className={styles.Column}>
            <div className={styles.Block}>
              <div>
                <div className={styles.imageWrapper}>
                  <img src={img2} alt="" />
                </div>
                <h4 className={styles.StepTitle}>Source Curated Salepeople</h4>
                <ul>
                  <li>Self-serve access</li>
                  <li>Filter by Experience</li>
                  <li>From $750/Month</li>
                </ul>
              </div>

              <Link className={styles.Request} to="/employer-signup/">
                Join Now
              </Link>
            </div>
          </div>

          <div className={styles.Column}>
            <div className={styles.Block}>
              <div>
                <div className={styles.imageWrapper}>
                  <img src={img3} alt="" />
                </div>
                <h4 className={styles.StepTitle}>Let Our Experts Deliver Your Next Sales Hire</h4>
                <ul>
                  <li>Full-cycle recruiting</li>
                  <li>Done entirely for you</li>
                  <li>Custom search and pricing</li>
                </ul>
              </div>

              <a className={styles.Request} href="mailto:sales@rainmakers.co">
                Talk to an Expert
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneCommunityThreeWays;
